"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ItemRecommendationFragment_1 = __importDefault(require("../fragments/ItemRecommendationFragment"));
const AdsItemsQuery = (0, graphql_tag_1.default) `
  query adsItemsQuery(
    $metadata: MetadataInput!
    $banners: [AdsBannerInput!]
    $products: [AdsProductInput!]
    $zipcode: String
    $omitProductIds: [String!]
    $offerOptions: OfferOptionsInput
  ) {
    ads(
      input: {
        metadata: $metadata
        banners: $banners
        products: $products
        zipcode: $zipcode
        omitProductIds: $omitProductIds
      }
    ) {
      banners {
        campaignId
        redirectUrl
        imageUrl
        trackId
        slot
      }
      items {
        trackId
        campaignId
        slot
        item {
          ...item
        }
      }
      fillrates {
        eventId
        placement
        received {
          serverAdsAmount
        }
        requested {
          categories
          serverAdsAmount
          skus
        }
        slotId
      }
    }
  }
  ${ItemRecommendationFragment_1.default}
`;
exports.default = AdsItemsQuery;
